import { ArrowDown } from "lucide-react";

export const ArrowConnector = () => {
  return (
    <div className="py-2 text-slate-800">
      <ArrowDown className="w-7 h-7" />
    </div>
  );
};